import { Action } from 'redux';

import { isSetRootAdminUiStateAction } from '../actions/spaces/RootAdminUiStateActions';
import { RootAdminUiState } from '../state/RootAdminUIState';

export function rootAdminUiStateReducer(
  previousState: RootAdminUiState = 'bootstrap',
  action: Action = null
): RootAdminUiState {

  if(isSetRootAdminUiStateAction(action) && previousState !== action.rootAdminUiState) {
    return action.rootAdminUiState;
  }

  return previousState;
}
